import { Box, Button, Flex, Heading, Text, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../contexts/userContext";
import { SETTINGS_PAGE } from "../../routes";

const StravaLoginCallbackPage = () => {
  const navigate = useNavigate();
  const user = useUser();
  const [error, setError] = useState<string | null>(null);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    const finalizeStravaConnectionAsync = async () => {
      try {
        await user.finalizeStravaConnectionAsync();
        setFinished(true);
        navigate(SETTINGS_PAGE);
      } catch (error) {
        console.error("An error occurred in finishConnectAsync:", error);
        setError(
          error instanceof Error ? error.message : "Unable to finish the Strava connection.",
        );
      }
    };

    finalizeStravaConnectionAsync();
  }, [navigate, user]);

  if (!error) {
    return null;
  }

  return (
    <Flex direction="column" align="center" justify="center" height="100vh" bg="secondary.800">
      <Box
        bg="secondary.900"
        p={6}
        boxShadow="md"
        borderRadius="lg"
        textAlign="center"
        minW="400px"
      >
        <VStack spacing={4}>
          <Heading size="lg">Strava Connection Failed</Heading>
          <Text>{error}</Text>
          <Button colorScheme="cyan" variant="outline" onClick={() => navigate(SETTINGS_PAGE)}>
            Back to Settings
          </Button>
          {finished ? null : (
            <Button colorScheme="orange" onClick={() => window.location.reload()}>
              Retry Callback
            </Button>
          )}
        </VStack>
      </Box>
    </Flex>
  );
};

export default StravaLoginCallbackPage;
